import { c as _c } from "react/compiler-runtime";
import { type ButtonHTMLAttributes, type DetailedHTMLProps, type MouseEvent } from 'react';
import { ChevronButton } from '@/components/ChevronButton';
import { cn } from '@/lib/cn';
import { useCarouselStateState } from './Carousel';
export interface CarouselButtonProps extends DetailedHTMLProps<ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  variant: 'prev' | 'next';
  center?: boolean;
}
export function CarouselNavigationButton(t0) {
  const $ = _c(32);
  let children;
  let className;
  let disabled;
  let onClick;
  let props;
  let t1;
  let variant;
  if ($[0] !== t0) {
    ({
      children,
      className,
      variant,
      disabled,
      onClick,
      center: t1,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = className;
    $[3] = disabled;
    $[4] = onClick;
    $[5] = props;
    $[6] = t1;
    $[7] = variant;
  } else {
    children = $[1];
    className = $[2];
    disabled = $[3];
    onClick = $[4];
    props = $[5];
    t1 = $[6];
    variant = $[7];
  }
  const center = t1 === undefined ? true : t1;
  const carouselState$ = useCarouselStateState();
  const t2 = `btn-${variant}`;
  const t3 = `btn-${variant} carousel-navigation-btn disabled:invisible absolute z-1`;
  const t4 = variant === "next";
  const t5 = variant === "prev";
  let t6;
  if ($[8] !== center || $[9] !== className || $[10] !== t3 || $[11] !== t4 || $[12] !== t5) {
    t6 = cn(t3, {
      "top-1/2 !-translate-y-1/2": center,
      "right-0": t4,
      "left-0": t5
    }, className);
    $[8] = center;
    $[9] = className;
    $[10] = t3;
    $[11] = t4;
    $[12] = t5;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== carouselState$.canScrollNext || $[15] !== carouselState$.canScrollPrev || $[16] !== disabled || $[17] !== variant) {
    t7 = () => disabled || variant === "next" ? !carouselState$.canScrollNext.get() : !carouselState$.canScrollPrev.get();
    $[14] = carouselState$.canScrollNext;
    $[15] = carouselState$.canScrollPrev;
    $[16] = disabled;
    $[17] = variant;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== carouselState$.emblaApi?.scrollNext || $[20] !== carouselState$.emblaApi?.scrollPrev || $[21] !== onClick || $[22] !== variant) {
    t8 = e => {
      const scrollFn = variant === "next" ? carouselState$.emblaApi?.scrollNext : carouselState$.emblaApi?.scrollPrev;
      if (scrollFn) {
        scrollFn();
      }
      onClick?.(e);
    };
    $[19] = carouselState$.emblaApi?.scrollNext;
    $[20] = carouselState$.emblaApi?.scrollPrev;
    $[21] = onClick;
    $[22] = variant;
    $[23] = t8;
  } else {
    t8 = $[23];
  }
  let t9;
  if ($[24] !== children || $[25] !== props || $[26] !== t2 || $[27] !== t6 || $[28] !== t7 || $[29] !== t8 || $[30] !== variant) {
    t9 = <ChevronButton variant={variant} data-testid={t2} className={t6} $disabled={t7} onClick={t8} {...props}>{children}</ChevronButton>;
    $[24] = children;
    $[25] = props;
    $[26] = t2;
    $[27] = t6;
    $[28] = t7;
    $[29] = t8;
    $[30] = variant;
    $[31] = t9;
  } else {
    t9 = $[31];
  }
  return t9;
}